import type {
  EntitySuggestion,
  ProcessDraftStep,
  ProcessStepRecordingDisplay
} from '@bliks-io/contracts';

export function draftStepToDisplay(
  step: ProcessDraftStep,
  processId: string,
  entitySuggestions: EntitySuggestion[] = []
): ProcessStepRecordingDisplay {
  return {
    nodeKind: 'step',
    _id: String(step.stableStepId),
    process: processId,
    previousStep: step.previousStep ?? null,
    recordedBy: undefined as unknown as ProcessStepRecordingDisplay['recordedBy'],
    assignedTo: step.assignedTo,
    assignedToModel: step.assignedToModel,
    whoElseDoesThis: (step.whoElseDoesThis ??
      []) as unknown as ProcessStepRecordingDisplay['whoElseDoesThis'],
    inputs: step.inputs ?? [],
    actionType: step.actionType ?? 'task',
    helpers: step.helpers as unknown as ProcessStepRecordingDisplay['helpers'],
    task: step.task as unknown as ProcessStepRecordingDisplay['task'],
    rules: step.rules as unknown as ProcessStepRecordingDisplay['rules'],
    entitySuggestions,
    // Drafts are pre-publish; treat them as in_progress for any consumer that
    // narrows on `status`. The real recording status is set when the draft is
    // applied to live via `apply-draft-to-live`.
    status: 'in_progress',
    generatedName: step.generatedName ?? null,
    generatedDescription: step.generatedDescription ?? null,
    laneKey: step.laneKey,
    createdAt: '',
    updatedAt:
      step.updatedAt instanceof Date ? step.updatedAt.toISOString() : String(step.updatedAt ?? '')
  };
}
